<div *ngIf="reg">
    <div class="row px-3">
        <div
            class="col-md-8 col-lg-10"
            style="font-size: 16px;"
        >
            <div>Test Type: {{reg.testTypeName}}</div>
            <div>Registration Number: {{reg.publicRegIdentifier}}</div>
            <div>
                <div
                    style="margin: 7px auto 7px auto;"
                    class="info-box-date-location"
                >
                    <strong>
                        Date: {{testDate | customDate: 'formatDateTime'}} <br />
                        (Time Zone: {{localTimeZone}})
                    </strong>
                </div>
            </div>
        </div>
        <div
            *ngIf="isUpcomingTest"
            class="col-md-4 col-lg-2"
        >
            <app-test-actions
                [reg]="reg"
                [isUpcomingTest]="isUpcomingTest"
            ></app-test-actions>
        </div>
        <div
            *ngIf="!reg.biometricConsent && isUpcomingTest"
            class="alert alert-danger m-3"
            role="alert"
        >
            Please update <a
                [routerLink]="['/account/biometric-consent']"
                class="alert-link"
            >biometric consent</a> before your test date
        </div>
    </div>
    <app-web-delivery-requirements></app-web-delivery-requirements>
    <app-start-my-test
        [myAccount]="myAccount$ | async"
        [businessAccountParentKey]="businessAccountParentKey$ | async"
        [isUpcomingTest]="isUpcomingTest"
        [reg]="reg"
    ></app-start-my-test>
</div>
